import { Directive, HostListener, Input } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';

@Directive({
    selector: '[appHideGridFilterPopupOnScrolling]',
    standalone: false
})
export class HideGridFilterPopupOnScrollingDirective {
  @Input() appHideGridFilterPopupOnScrolling: DxDataGridComponent;
  constructor() {}

  @HostListener('document:wheel', ['$event']) onMousewheel(event) {
    let isScrollBarVisible = false;
    let isInside = false;
    let target = event.target;
    if (this.appHideGridFilterPopupOnScrolling) {
    while(target && !isInside) {
      isScrollBarVisible = document.body.clientHeight <= target.clientHeight || isScrollBarVisible;
      isInside = target.classList.contains('dx-item') || target.classList.contains('dx-header-filter-menu');
      target = target.parentElement;
    }
    if (!isInside && isScrollBarVisible) {
      const gridInstance = this.appHideGridFilterPopupOnScrolling.instance as any;
      const headerView = gridInstance.getController('headerFilter').getView('headerFilterView');
      if (headerView.getPopupContainer()) {
        headerView.getPopupContainer().hide();
       }
      }
    }
  }
}
